var _rect, _path, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCareMatrixIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 37,
    viewBox: "0 0 31 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.13971,
    y: 6.61041,
    width: 28.7206,
    height: 28.7206,
    stroke: "black",
    strokeWidth: 2.27941
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.227941 1.36765C0.227941 0.738206 0.738205 0.227941 1.36765 0.227941H29.6324C30.2618 0.227941 30.7721 0.738205 30.7721 1.36765V5.24265H0.227941V1.36765Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.455882
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 21.1982,
    x2: 31,
    y2: 21.1982,
    stroke: "black",
    strokeWidth: 2.27941
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 15.7275,
    y1: 36.4707,
    x2: 15.7275,
    y2: 5.4707,
    stroke: "black",
    strokeWidth: 2.27941
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareMatrixIcon);
export default __webpack_public_path__ + "static/media/care_matrix_icon.943c5192befe4540b833fd522bc19fc1.svg";
export { ForwardRef as ReactComponent };